module.exports = __webpack_public_path__ + "img/KABARD.3663d3df.png";